export default __webpack_public_path__ + "static/media/blackboard.e438daf6.gif";